// Accessibility fixes for third-party apps and theme elements
(function() {
  function applyFixes() {
    // Wishlist Guru hearts
    document.querySelectorAll('.wg-collectionIcon:not([aria-label])').forEach(function(el) {
      el.setAttribute('aria-label', 'Add to wishlist');
    });
    
    var headerHeart = document.querySelector('.header-heart-position:not([aria-label])');
    if (headerHeart) {
      headerHeart.setAttribute('aria-label', 'Open wishlist');
    }

    // Cart icon
    var cartIcon = document.querySelector('.header__icon--cart:not([aria-label])');
    if (cartIcon) {
      cartIcon.setAttribute('aria-label', 'View cart');
    }

    // Add more fixes here as needed
  }

  applyFixes();
  var observer = new MutationObserver(applyFixes);
  observer.observe(document.body, { childList: true, subtree: true });
})();